<template>
  <div class="w-full flex flex-col ">
    <h2 class="text-center font-bold  p-4">Perfil de Salud</h2>
    <form @submit.prevent="guardarPerfilSalud">
      <!-- Peso Actual -->
      <div class="mb-6">
        <label for="pesoActual" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Peso Actual
          (lb):</label>
        <input type="number" v-model="perfilSalud.pesoActual"
          class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          required />
      </div>

      <!-- Peso Meta -->
      <div class="form-group mb-3">
        <label for="pesoMeta" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Peso Meta
          (lb):</label>
        <input type="number" v-model="perfilSalud.pesoMeta"
          class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          required />
      </div>

      <!-- Nivel de Actividad Física -->
      <div class="form-group mb-3">
        <label for="actividadFisica">Nivel de Actividad Física:</label>
        <select v-model="perfilSalud.actividadFisica"
          class="bg-gray-50 border border-gray-300 text-gray-900 mb-6 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
          <option value="mucha">Mucha</option>
          <option value="moderada">Moderada</option>
          <option value="poca">Poca</option>
          <option value="ninguna">Ninguna</option>
        </select>
      </div>

      <!-- Minutos de Actividad Física Semanal -->
      <div class="form-group mb-3">
        <label for="minutosActividad" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Minutos de
          Actividad Física Semanal:</label>
        <input type="number" v-model="perfilSalud.minutosActividad"
          class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          required />
      </div>

      <!-- Comidas Diarias -->
      <div class="flex flex-col w-full mb-3">
        <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Comidas Diarias:</label>
        <div v-for="(comida, index) in comidas" :key="index" class="flex flex-row w-max gap-3 items-end">
          <input type="checkbox" :value="comida" v-model="perfilSalud.comidasDiarias"
            class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500" />
          <label class="form-check-label">{{ comida }}</label>
        </div>
      </div>

      <!-- Calorías Diarias -->
      <div class="flex flex-col w-full mb-3">
        <label for="caloriasDiarias" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Calorías
          Consumidas Diarias (kcal):</label>
        <input type="number" v-model="perfilSalud.caloriasDiarias"
          class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          required />
      </div>

      <!-- Consumo de Bebidas Alcohólicas -->
      <div class="flex flex-col w-full mb-3">
        <label for="bebidasAlcohol" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Consumo de
          Bebidas Alcohólicas:</label>
        <select v-model="perfilSalud.bebidasAlcohol"
          class="bg-gray-50 border border-gray-300 text-gray-900 mb-6 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
          <option value="mucho">Mucho</option>
          <option value="moderado">Moderado</option>
          <option value="poco">Poco</option>
          <option value="ninguno">Ninguno</option>
        </select>
      </div>

      <!-- Fuma o No Fuma -->
      <div class="flex flex-col w-full mb-3">
        <label for="fuma" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Fuma:</label>
        <select v-model="perfilSalud.fuma"
          class="bg-gray-50 border border-gray-300 text-gray-900 mb-6 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
          <option value="si">Sí</option>
          <option value="no">No</option>
        </select>
      </div>

      <!-- Botón Guardar -->
      <button type="submit"
        class="text-white w-full whitespace-nowrap bg-blue-700 hover:bg-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded-full text-sm px-5 py-2.5 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Guardar
        Perfil de Salud</button>
    </form>
  </div>
</template>

<script>
import { doc, setDoc, getDoc } from "firebase/firestore";
import { db } from "@/firebase"; // Ajustar según tu configuración

export default {
  name: "PerfilSalud",
  data() {
    return {
      pacienteId: this.$route.params.pacienteId, // Suponiendo que el ID viene de la URL
      perfilSalud: {
        pesoActual: null,
        pesoMeta: null,
        actividadFisica: "",
        minutosActividad: null,
        comidasDiarias: [],
        caloriasDiarias: null,
        bebidasAlcohol: "",
        fuma: "",
      },
      comidas: ["Desayuno", "Merienda Mañana", "Almuerzo", "Merienda Tarde", "Cena", "Merienda Noche"],
    };
  },
  async mounted() {
    await this.cargarPerfilSalud();
  },
  methods: {
    async cargarPerfilSalud() {
      try {
        const docRef = doc(db, "pacientes", this.pacienteId, "perfilSalud", "detalles");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          this.perfilSalud = docSnap.data();
        } else {
          //("No se encontró el perfil de salud.");
        }
      } catch (error) {
        console.error("Error al cargar el perfil de salud:", error);
      }
    },
    async guardarPerfilSalud() {
      try {
        const docRef = doc(db, "pacientes", this.pacienteId, "perfilSalud", "detalles");
        await setDoc(docRef, this.perfilSalud);
        alert("Perfil de salud guardado correctamente.");
      } catch (error) {
        console.error("Error al guardar el perfil de salud:", error);
      }
    },
  },
};
</script>

<style scoped></style>
